import Button from "../common/Button";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { useEffect, useRef } from "react";
import {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
  interpolateColor,
} from "react-native-reanimated";
import { theme } from "@theme";
import { router } from "expo-router";

const WHITE = theme.colors.white;
const ARTIST_GREEN = theme.colors.artistGreen;

const MyTickets = ({
  recentlyPurchased,
  accessId,
}: {
  recentlyPurchased: boolean;
  accessId: string;
}) => {
  const pulseProgress = useSharedValue(0);
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (recentlyPurchased && !hasTriggered.current) {
      hasTriggered.current = true;
      // Continuously pulsate
      pulseProgress.value = withRepeat(
        withTiming(1, { duration: 600 }),
        -1,
        true,
      );
    }
  }, [recentlyPurchased]);

  const animatedStyle = useAnimatedStyle(() => {
    if (!recentlyPurchased && !hasTriggered.current) {
      return { backgroundColor: WHITE };
    }

    return {
      backgroundColor: interpolateColor(
        pulseProgress.value,
        [0, 1],
        [WHITE, ARTIST_GREEN],
      ),
    };
  });

  return (
    <Button.Button
      onPress={() => {
        router.push({
          pathname: "/(app)/access/[accessId]/view-tickets",
          params: { accessId },
        });
      }}
      sentryEventName="AccessDetail.Event.MyTickets"
      style={animatedStyle}
    >
      <LIcon colors={{ color: "black" }} name="ticket" size={16} />
      <LText variant="Caption/C1/Medium" color="black">
        My Tickets
      </LText>
    </Button.Button>
  );
};

export default MyTickets;
